<mat-card>
    <mat-card-header class="titreFrm">
      <mat-card-title>{{title}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
      <div *ngIf="exist;else attente"></div>
      <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
        <!-------------------- bouton --------------------->
        <div class="btn">
            <mat-form-field     appearance="outline" >
              <mat-label>Année</mat-label>
                <mat-select [disabled]="disabled" name="session" [(ngModel)]="annee" placeholder="Année" (selectionChange)="onAnneeChange()">
                  <mat-option *ngFor="let a of listeAnnee" [value]="a">
                    {{a}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
            <div>
                <span class="button-row">
                    <button (click)="ajouterEvaluation()" mat-raised-button class="colorGreen"> <mat-icon>add</mat-icon>Ajouter</button>
                </span>
                <span class="button-row">
                    <button (click)="showEvaluation()" mat-raised-button class="colorRed"> <mat-icon>edite</mat-icon>Modifier</button>
                </span>
                <span class="button-row">
                    <button (click)="showEvaluation()" mat-raised-button class="colorBlue"> <mat-icon>search</mat-icon>Imprimer</button>
                </span>
                <span class="button-row">
                    <button (click)="showEvaluation()" mat-raised-button class="colorGray"> <mat-icon>import_contacts</mat-icon>Consulter</button>
                </span>
                <!-- <span class="button-row">
                    <button (click)="listeColl()" mat-raised-button class="colorRed"> <mat-icon>format_list_bulleted</mat-icon>Supprimer évaluation</button>
                </span>    -->
            </div>

        </div>
        <!-------------------- fin bouton --------------------->
        <!--  -->
        <app-avt-listes 
          *ngIf="showListeEvaluation"
          #listeEvaluationComponen 
          [showFilter]="false" 
          [heightTable]="'400'" 
          [dataSourceBrut]="[]" 
          [displayedColumnsBrut]="columnsEvaluation"
          >
        </app-avt-listes>
    </mat-card-content>
</mat-card>